/**
 * [CRO] PLP card image gallery — progress bar + arrow navigation*/
(function () {
  'use strict';

  function initGallery(gallery) {
    if (gallery.dataset.galleryInit === 'true') return;
    gallery.dataset.galleryInit = 'true';

    const track = gallery.querySelector('[data-gallery-track]');
    const progressBar = gallery.querySelector('[data-gallery-progress-bar]');
    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    if (!track) return;

    const totalSlides = parseInt(track.dataset.galleryCount || '1', 10);
    if (totalSlides <= 1) return;

    function getActiveIndex() {
      const slideWidth = track.scrollWidth / totalSlides;
      return Math.round(track.scrollLeft / slideWidth);
    }

    function updateProgress() {
      if (!progressBar) return;
      const barWidth = 100 / totalSlides;
      const scrollMax = track.scrollWidth - track.clientWidth;
      const scrollRatio = scrollMax > 0 ? track.scrollLeft / scrollMax : 0;
      const translateX = scrollRatio * (totalSlides - 1) * 100;
      progressBar.style.width = `${barWidth}%`;
      progressBar.style.transform = `translateX(${translateX}%)`;

      // Update arrow visibility
      const activeIdx = getActiveIndex();
      if (prevBtn) prevBtn.hidden = activeIdx <= 0;
      if (nextBtn) nextBtn.hidden = activeIdx >= totalSlides - 1;
    }

    // Initial state
    updateProgress();

    // Scroll handler — update progress bar
    let scrollRaf = null;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(updateProgress);
      },
      { passive: true }
    );

    // Arrow click handlers
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const idx = getActiveIndex();
        const target = track.children[Math.max(0, idx - 1)];
        if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const idx = getActiveIndex();
        const target = track.children[Math.min(totalSlides - 1, idx + 1)];
        if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    }

    // Prevent arrow clicks from bubbling up to the parent anchor (product link)
    [prevBtn, nextBtn].forEach((btn) => {
      if (!btn) return;
      ['mousedown', 'touchstart'].forEach((evt) =>
        btn.addEventListener(evt, (e) => e.stopPropagation(), { passive: true })
      );
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-card-gallery]').forEach(initGallery);
  }

  // Watch for dynamically loaded cards (load-more, filter, infinite-scroll)
  function watchForGalleries() {
    const observer = new MutationObserver((mutations) => {
      let foundNew = false;
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (
            node.matches?.('[data-product-card-gallery]') ||
            node.querySelector?.('[data-product-card-gallery]')
          ) {
            foundNew = true;
            break;
          }
        }
        if (foundNew) break;
      }
      if (foundNew) initAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll();
      watchForGalleries();
    });
  } else {
    initAll();
    watchForGalleries();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAll);
  }
})();